export const BRAND_INFO = {
    BRAND_INFO: "brand_info",
    BRAND_CONTACT_INFO: "brand_contact_info",
    BRAND_CURRENCIES: "brand_currencies",
    BRAND_DEFAULT_CURRENCY: "brand_default_currency",
    BRAND_IMAGE_NAME_CONVENTION: "brand_image_name_convention",
    BRAND_ENABLED_MODULES: "brand_enabled_modules",
    BRAND_CUSTOM_SCRIPTS: "brand_custom_scripts",
    BRAND_PREFERENCES: "brand_preferences",
};
